// Whether a failed query is worth retrying.
//
// A LEAF module on purpose: five test files `mock.module` v2/configs/rq-setup with a
// 2-3 method stub, and those mocks leak process-globally (AGENTS.md failure mode 1),
// so a test importing this from rq-setup would die with "Export named ... not found"
// in whichever file ran later. Nothing here imports anything.
const statusOf = (error: unknown): number | undefined =>
  (error as { response?: { status?: number } })?.response?.status

export const QUERY_MAX_RETRIES = 3

export const shouldRetryQuery = (failureCount: number, error: unknown): boolean => {
  const status = statusOf(error)
  // A 400 (bad params), a 403 (refused, e.g. a route hodor denies an embed session)
  // and a 404 (absent resource) are deterministic — asking again cannot change the
  // answer, and each retry keeps the query PENDING through 1s + 2s + 4s of backoff,
  // blocking every caller that gates on isLoading.
  if (status === 400 || status === 403 || status === 404) return false
  // Everything else keeps the default retries (401s self-heal after a token refresh).
  return failureCount < QUERY_MAX_RETRIES
}
